import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LoggerService, tryNormalizeHttpError, SiteConnector } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import {
  bufferCount,
  catchError,
  exhaustMap,
  filter,
  map,
} from 'rxjs/operators';
import { SiteContextActions } from '../actions/index';
import { getActiveLanguage } from '../selectors/languages.selectors';
import { StateWithSiteContext } from '../state';

@Injectable()
export class LanguagesEffects {
  protected logger = inject(LoggerService);

  loadLanguages$: Observable<
    | SiteContextActions.LoadLanguagesSuccess
    | SiteContextActions.LoadLanguagesFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteContextActions.LOAD_LANGUAGES),
      exhaustMap(() => {
        return this.siteConnector.getLanguages().pipe(
          map(
            (languages) =>
              new SiteContextActions.LoadLanguagesSuccess(languages)
          ),
          catchError((error) =>
            of(
              new SiteContextActions.LoadLanguagesFail(
                tryNormalizeHttpError(error, this.logger)
              )
            )
          )
        );
      })
    )
  );

  activateLanguage$: Observable<SiteContextActions.LanguageChange> =
    createEffect(() =>
      this.state.select(getActiveLanguage).pipe(
        bufferCount(2, 1),

        // avoid dispatching `change` action when we're just setting the initial value:
        filter(([previous]) => !!previous),
        map(
          ([previous, current]) =>
            new SiteContextActions.LanguageChange({ previous, current })
        )
      )
    );

  constructor(
    private actions$: Actions,
    private siteConnector: SiteConnector,
    private state: Store<StateWithSiteContext>
  ) {}
}
